import { darkVariablesArr, sizeVariablesArr } from '../Water.variables';

const WaterDarkTheme = {
  metadata: {
    id: 'water-dark',
    name: { enUS: 'Water Dark', ptBR: 'Water Dark', esES: 'Water Dark' },
    isDark: true,
  },
  colors: darkVariablesArr,
  sizes: sizeVariablesArr,
};

export { WaterDarkTheme };
